export const SKILLS = [
    // Expert Level (XL)
    { name: 'React', category: 'framework', size: 'xl' },
    { name: 'React Native', category: 'framework', size: 'xl' },
    { name: 'JavaScript', category: 'language', size: 'xl' },
    { name: 'TypeScript', category: 'language', size: 'xl' },
    { name: 'Redux', category: 'state', size: 'xl' },
    // Advanced Level (LG)
    { name: 'Node.js', category: 'language', size: 'lg' },
    { name: 'Express', category: 'tool', size: 'lg' },
    { name: 'CSS', category: 'styling', size: 'lg' },
    { name: 'Git', category: 'tool', size: 'lg' },
    { name: 'Jest', category: 'testing', size: 'lg' },
    { name: 'SSR', category: 'tool', size: 'lg' },
    { name: 'Video Playback', category: 'tool', size: 'lg' },
    { name: 'DRM', category: 'tool', size: 'lg' },
    // Intermediate Level (MD)
    { name: 'React Native for Web', category: 'framework', size: 'md' },
    { name: 'Handlebars', category: 'tool', size: 'md' },
    { name: 'Jenkins', category: 'tool', size: 'md' },
    { name: 'CI/CD', category: 'tool', size: 'md' },
    { name: 'A/B Testing', category: 'tool', size: 'md' },
    { name: 'Webpack', category: 'tool', size: 'md' },
    { name: 'GraphQL', category: 'tool', size: 'md' },
    { name: 'HLS/DASH', category: 'tool', size: 'md' },
    { name: 'CTV', category: 'tool', size: 'md' },
];
